import { ShipmentInActionDetailDto } from 'src/generated/services/TFinancialApi';
import clsx from 'clsx';
import Location from './Location';
import Transport from './Transport';

interface ITransportSummaryProps {
  data: ShipmentInActionDetailDto;
}

export const TransportSummary: React.FC<ITransportSummaryProps> = ({ data }) => {
  const dataTransport = data?.transportDetail;
  const legOneDetail = data?.legDetails?.find((check) => check?.type === 'LEG_ONE');
  const legTwoDetail = data?.legDetails?.find((check) => check?.type === 'LEG_TWO');
  const legThreeDetail = data?.legDetails?.find((check) => check?.type === 'LEG_THREE');

  return (
    <div className='relative w-full'>
      <div className='flex justify-between w-full'>
        {dataTransport?.legOne && (
          <>
            <Location
              title={dataTransport?.legOne?.startLocation}
              position='start'
              date={dataTransport?.legOne?.startDate}
              disabled={!legOneDetail}
              transportMedium={dataTransport?.legOne?.transportMedium}
            />
            <Transport type={dataTransport?.legOne?.transportMedium} disabled={!legOneDetail.invoices.length} />
          </>
        )}
        {dataTransport?.legTwo && (
          <>
            <Location
              title={dataTransport?.legTwo?.startLocation}
              position='center'
              date={dataTransport?.legTwo?.startDate}
              dateType='etd'
              disabled={!legTwoDetail}
              transportMedium={dataTransport?.legTwo?.transportMedium}
            />
            <Transport
              type={dataTransport?.legTwo?.transportMedium}
              disabled={!legTwoDetail.invoices.length}
              title={dataTransport?.legTwo?.route}
              tooltipContent={
                dataTransport?.legTwo?.zones && dataTransport.legTwo.zones.length > 0 ? (
                  <div className='flex items-center flex-wrap -mx-8 px-10 max-h-[320px] overflow-auto max-w-[150px]'>
                    {dataTransport.legTwo.zones.map((item, _index, arr) => (
                      <div key={`${item?.pol}-${item?.pod}`} className={clsx('px-8', arr.length > 1 ? 'w-1/2' : '')}>
                        <div className='py-2'>{`${item?.pol} - ${item?.pod}`}</div>
                      </div>
                    ))}
                  </div>
                ) : null
              }
            />

            <Location
              title={dataTransport?.legTwo?.deliveryLocation}
              position='center'
              date={dataTransport?.legTwo?.deliveryDate}
              dateType='eta'
              disabled={!legThreeDetail}
              transportMedium={dataTransport?.legTwo?.transportMedium}
            />
          </>
        )}
        {dataTransport?.legThree && (
          <>
            <Transport type={dataTransport?.legThree?.transportMedium} disabled={!legThreeDetail.invoices.length} />
            <Location
              title={dataTransport?.legThree?.deliveryLocation}
              position='end'
              date={dataTransport?.legThree?.deliveryDate}
              disabled={!legThreeDetail}
              transportMedium={dataTransport?.legThree?.transportMedium}
            />
          </>
        )}
      </div>
    </div>
  );
};
